module.exports = __webpack_public_path__ + "media/images/site/semi_trote-de72804de4674e2f55415d1d858a31e3.jpg";